'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlIpv = require('./validateUrlIpv4');

var _validateUrlIpv2 = _interopRequireDefault(_validateUrlIpv);

var _validateUrlIpv3 = require('./validateUrlIpv6');

var _validateUrlIpv4 = _interopRequireDefault(_validateUrlIpv3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Punting on IPvFuture for now
var validateUrlIp = (0, _regexSupplant2.default)('(?:' + '#{validateUrlIpv4}|' + '#{validateUrlIpv6}' + ')', { validateUrlIpv4: _validateUrlIpv2.default, validateUrlIpv6: _validateUrlIpv4.default }, 'i'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validateUrlIp;
module.exports = exports['default'];